import type { IValidatedResponse } from '../../httpClient';
import { postRequest } from '../../httpClient';
import type { IBulkDraftChallengesBody } from './bulk-draft-challenges-request';
import type { IBulkDraftChallengesResponse } from './bulk-draft-challenges-response';
import { bulkDraftChallengesResponseSchema } from './bulk-draft-challenges-response';

export async function bulkDraftChallengesApi(
  body: IBulkDraftChallengesBody,
): Promise<IValidatedResponse<IBulkDraftChallengesResponse>> {
  return postRequest<IBulkDraftChallengesResponse>({
    path: '/sys/challenges/draft',
    body,
    schema: bulkDraftChallengesResponseSchema,
  });
}
